import { definePreset, palette, type ColorScale } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const keolisPrimary = palette('#03A9C1');
const keolisSecondary = palette('#776E65');
const keolisSurfaceLight = palette('#64748b') as ColorScale;
const keolisSurfaceDark = palette('#1A1A1A') as ColorScale;

const KeolisAuraPreset = definePreset(Aura, {
  primitive: {
    keolisPrimary,
    keolisSecondary,
  },
  semantic: {
    primary: keolisPrimary,
    colorScheme: {
      light: {
        surface: {
          0: '#FFFFFF',
          ...keolisSurfaceLight,
        },
        primary: {
          color: '{primary.500}',
          contrastColor: '#FFFFFF',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        secondary: {
          color: '{keolisSecondary.500}',
          contrastColor: '#FFFFFF',
          hoverColor: '{keolisSecondary.600}',
          activeColor: '{keolisSecondary.700}',
        },
      },
      dark: {
        surface: {
          0: '#050505',
          ...keolisSurfaceDark,
        },
        primary: {
          color: '{primary.400}',
          contrastColor: '#1A1A1A',
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}',
        },
        secondary: {
          color: '{keolisSecondary.300}',
          contrastColor: '#1A1A1A',
          hoverColor: '{keolisSecondary.200}',
          activeColor: '{keolisSecondary.100}',
        },
      },
    },
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '{primary.300}',
      offset: '2px',
    },
  },
  components: {
    datatable: {
      colorScheme: {
        light: {
          row: {
            hoverBackground: '{primary.100}',
            hoverColor: '{primary.700}',
          },
        },
        dark: {
          row: {
            hoverBackground: '{primary.900}',
            hoverColor: '{primary.100}',
          },
        },
      },
    },
    progressspinner: {
      colorScheme: {
        light: {
          root: {
            colorOne: '{primary.color}',
            colorTwo: '{primary.color}',
            colorThree: '{primary.color}',
            colorFour: '{primary.color}',
          },
        },
        dark: {
          root: {
            colorOne: '{primary.color}',
            colorTwo: '{primary.color}',
            colorThree: '{primary.color}',
            colorFour: '{primary.color}',
          },
        },
      },
    },
    chip: {
      colorScheme: {
        light: {
          root: { background: '{surface.0}', color: '{primary.color}' },
          icon: { color: '{primary.color}' },
          removeIcon: { color: '{red.500}' },
        },
        dark: {
          root: { background: '{surface.800}', color: '{primary.color}' },
          icon: { color: '{primary.color}' },
          removeIcon: { color: '{red.400}' },
        },
      },
    },
  },
});

export default KeolisAuraPreset;
